import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fc582f4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fixed-asset-operator" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置 ")
const _hoisted_4 = { class: "mb-15" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 新增变动 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("登记入库")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 领用 ", -1))
const _hoisted_8 = { class: "d-flex mt-20" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("添加 ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_12 = { class: "d-flex justify-content--center" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_14 = { class: "dialog-footer" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("确 定 ")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 退库 ", -1))
const _hoisted_18 = { class: "d-flex mt-20" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_20 = { class: "d-flex mt-20" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_22 = { class: "dialog-footer" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("确 定 ")
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 报废 ", -1))
const _hoisted_26 = { class: "d-flex mt-20" }
const _hoisted_27 = { class: "d-flex mt-20" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("添加 ")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_30 = { class: "d-flex justify-content--center" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_32 = { class: "dialog-footer" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("确 定 ")

import Api from "@/http/modules";
import {
  action_bf,
  action_ly,
  action_tk,
  fixed_actions,
  fixed_asset_status_idle,
  fixed_asset_status_using
} from './OfficeAssetUtils'
import {reactive, ref, watch} from "vue";

import RegisterFixedDialog from "@/views/ViewsComponents/officeAssets/RegisterFixedDialog.vue";
import {ElMessage} from "element-plus";
import AsyncUploadButton from "@/components/AsyncUploadButton.vue";
import {exportHandle} from "@/utils";
import FixedAssetListDialog from "@/views/ViewsComponents/officeAssets/FixedAssetListDialog.vue";
import dayjs from "dayjs";


export default /*#__PURE__*/_defineComponent({
  props: {
    orgList: null,
    companyList: null,
    categoryList: null,
    usersListApi: null,
    registerApi: null,
    callback: null
  },
  emits: ['dialogShow','search'],
  setup(__props: any, { emit }) {

const props = __props as {
  orgList: any[],
  companyList: any[],
  categoryList: any[],
  usersListApi: (param: any) => Promise<any>,
  registerApi: (param: any) => Promise<any>,
  callback: (obj: { command: string, data: any }) => any
}

const {

  "POST/office/asset/batch_register_fixed_assets": batchRegisterFixedAssetsApi,
  "GET/office/asset/download_batch_register_template": downloadTemplateApi,
  "GET/office/asset/batch_register_fixed_assets_errors": batchRegisterCheckApi,
  "POST/office/asset/fixed_list": fixedAssetListApi,
  "POST/office/asset/ly_fixed_assets": lyApi,
  "POST/office/asset/return": tkApi,
  "POST/office/asset/discard": bfApi,
} = Api


emit("dialogShow")
const registerFixedDialogInfo = reactive({
  isShow: false
})

const showRegisterDialog = () => {
  registerFixedDialogInfo.isShow = false;
  emit("dialogShow")
  setTimeout(() => {
    registerFixedDialogInfo.isShow = true;
  }, 10)
}

const key = ref<string>()
const downloadErrors = () => {
  exportHandle(batchRegisterCheckApi, {key: key.value, progress: null})
      .then(() => {
      })
}
const batchImportResult = reactive({
  completed: false,
  total: 0,
  successCount: 0,
  failureCount: 0,
  downloadErrors: downloadErrors
})

const checkImportResult = async (res: any) => {
  try {
    key.value = res.key
    const obj = await batchRegisterCheckApi({key: res.key, progress: "true"})
    if (obj.completed) {
      batchImportResult.total = obj.rows
      batchImportResult.failureCount = obj.errorItems.length
      batchImportResult.successCount = batchImportResult.total - batchImportResult.failureCount
      batchImportResult.completed = true
    }
    return obj.completed
  } catch (e) {
  }
  return false;
}

const asyncUploadDialogVisible = (visible: boolean) => {
  if (visible) {
    batchImportResult.completed = false
    batchImportResult.total = 0
    batchImportResult.successCount = 0
    batchImportResult.failureCount = 0
  }
}

const lyForm = reactive<{
  userId: number | null,
  date: string | null,
  ids: number[]
}>({
  userId: null,
  date: null,
  ids: []
})
const tkForm = reactive<{
  userId: number | null,
  ids: number[],
  date: string | null,
  reason: string | null
}>({
  userId: null,
  ids: [],
  date: null,
  reason: null
})
const bfForm = reactive<{
  ids: number[],
  date: string | null,
  reason: string | null
}>({
  ids: [],
  date: dayjs().format('YYYY-MM-DD'),
  reason: null
})
const lyFormRef = ref()
const tkFormRef = ref()
const bfFormRef = ref()

const userInfo = reactive({
  userList: [],
  loading: false,
  key: null
})
const fixedAssetListDialogInfo = reactive<{
  isShow: boolean,
  status: string[] | null,
  type: string,
  filterBind: boolean,
  selectedList: any[],
}>({
  isShow: false,
  status: null,
  type: '',
  filterBind: false,
  selectedList: []
})
const showFixedAssetListDialog = (type: string) => {
  fixedAssetListDialogInfo.type = type
  if (type == action_ly) {
    fixedAssetListDialogInfo.status = [fixed_asset_status_idle]
  } else if (type == action_bf) {
    fixedAssetListDialogInfo.status = [fixed_asset_status_idle, fixed_asset_status_using]
  } else {
    //tk
    fixedAssetListDialogInfo.status = [fixed_asset_status_using]
  }
  fixedAssetListDialogInfo.isShow = false
  setTimeout(() => {
    fixedAssetListDialogInfo.isShow = true
  }, 10)
  emit("dialogShow")
}
const onAssetSelected = (list: any[]) => {
  let temp = fixedAssetListDialogInfo.selectedList
  for (let i = 0; i < list.length; i++) {
    if (temp.filter(item => item.id == list[i].id).length < 1) {
      temp.push(list[i])
    }
  }
  fixedAssetListDialogInfo.selectedList = temp
}

const deleteBindAsset = (asset: any) => {
  fixedAssetListDialogInfo.selectedList = fixedAssetListDialogInfo.selectedList.filter(i => i.id != asset.id)
}

const onTkAssetSelected = (list: any[]) => {
  tkDialogInfo.selected = list;
}

watch(() => tkForm.userId, (cur, old) => {
  if (cur) {
    // console.log("tk user id change")
    fixedAssetListDialogInfo.selectedList = []
    fixedAssetListApi({page: 1, size: 1000, status: [fixed_asset_status_using], ownerId: cur})
        .then((r: any) => {
          fixedAssetListDialogInfo.selectedList = r.data
          console.log("tk user selected", r.data)
        })

  }
})
const disableDate = (date: Date) => {
  return dayjs(date).isAfter(new Date())
}

const lyDialogInfo = reactive({
  isShow: false,
  loading: false
})
const tkDialogInfo = reactive<{
  isShow: boolean,
  loading: boolean,
  selected: any[]
}>({
  isShow: false,
  loading: false,
  selected: []
})
const bfDialogInfo = reactive({
  isShow: false,
  loading: false
})
const queryUser = (key?: string) => {
  if (key == userInfo.key) {
    return
  }
  userInfo.loading = true
  props.usersListApi({page: 1, size: 100, query: key}).then((r: any) => {
    userInfo.loading = false
    userInfo.userList = r.data.map((i: any) => {
      return {
        userId: i.userId,
        label: i.realName + "(" + i.alias + ")"
      }
    })
  }).catch((e: any) => {
    userInfo.loading = false
  })
}
const handCommand = (command: string) => {
  fixedAssetListDialogInfo.selectedList = []
  if (action_ly == command) {

    lyDialogInfo.isShow = true
    setTimeout(() => {
      lyFormRef.value.resetFields()
    }, 10)
    //领用
  } else if (action_tk == command) {
    //退库
    tkDialogInfo.isShow = true
    setTimeout(() => {
      tkFormRef.value.resetFields()
    }, 10)
  } else if (action_bf == command) {
    //报废
    bfForm.date = dayjs().format('YYYY-MM-DD');
    bfDialogInfo.isShow = true
    setTimeout(() => {
      bfFormRef.value.resetFields()
    }, 10)
  } else {
    //ignore
  }
  queryUser("")

}
//领用
const ly = () => {
  lyFormRef.value.validate((valid: boolean) => {
    if (valid) {
      lyForm.ids = fixedAssetListDialogInfo.selectedList.map(i => i.id)
      if (lyForm.ids.length < 1) {
        ElMessage.warning("请添加领用的资产")
        return
      }
      lyDialogInfo.loading = true
      lyApi(lyForm).then((r: any) => {
        lyDialogInfo.loading = false
        lyDialogInfo.isShow = false
        ElMessage.success("领用成功")
        props.callback({command: action_ly, data: null})
      }).catch((e: any) => {
        lyDialogInfo.loading = false
        ElMessage.success("领用失败：" + e)
      })
    } else {
      return false
    }
  })
}
//退库
const tk = () => {
  tkFormRef.value.validate((valid: boolean) => {
    if (valid) {
      tkForm.ids = tkDialogInfo.selected.map(i => i.id)
      if (tkForm.ids.length < 1) {
        ElMessage.warning("请添加退库的资产")
        return
      }
      tkDialogInfo.loading = true
      tkApi(tkForm).then((r: any) => {
        tkDialogInfo.loading = false
        tkDialogInfo.isShow = false
        ElMessage.success("退库成功")
        props.callback({command: action_tk, data: null})
      }).catch((e: any) => {
        tkDialogInfo.loading = false
        ElMessage.success("退库失败：" + e)
      })
    } else {
      return false
    }
  })
}
const bf = () => {
  bfFormRef.value.validate((valid: boolean) => {
    if (valid) {
      bfForm.ids = fixedAssetListDialogInfo.selectedList.map(i => i.id)
      if (bfForm.ids.length < 1) {
        ElMessage.warning("请添加报废的资产")
        return
      }
      bfDialogInfo.loading = true
      bfApi(bfForm).then((r: any) => {
        bfDialogInfo.loading = false
        bfDialogInfo.isShow = false
        ElMessage.success("报废成功")
        props.callback({command: action_bf, data: null})
      }).catch((e: any) => {
        bfDialogInfo.loading = false
        ElMessage.success("报废失败：" + e)
      })
    } else {
      return false
    }
  })
}
const searchEle = ref()
const searchObj = reactive<{
  orgId: null | number,
  companyId: null | number,
  date: string[],
}>({
  orgId: null,
  companyId: null,
  date: []
})
const search = () => {
  console.log("search 1",searchObj)
  emit("search", {orgId:searchObj.orgId,companyId:searchObj.companyId,date:searchObj.date})
}


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_ArrowDown = _resolveComponent("ArrowDown")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_eptBtn = _resolveComponent("eptBtn")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_el_collapse, { class: "mb-15" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_collapse_item, {
            title: "搜索",
            name: "1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                class: "searchContent searchBg",
                model: _unref(searchObj),
                "label-width": "90px",
                inline: true,
                ref_key: "searchEle",
                ref: searchEle,
                "label-position": "right"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "所属团队:",
                    prop: "orgId",
                    class: "flex-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _unref(searchObj).orgId,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).orgId) = $event)),
                        placeholder: "所属团队",
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.orgList, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.name,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "所属公司:",
                    prop: "companyId",
                    class: "flex-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _unref(searchObj).companyId,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchObj).companyId) = $event)),
                        placeholder: "所属公司",
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysCompany, (group) => {
                            return (_openBlock(), _createBlock(_component_el_option_group, {
                              label: group.label,
                              key: group.label
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: item.name,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "变动日期:",
                    prop: "date"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        type: "monthrange",
                        "range-separator": "至",
                        "value-format": "YYYY-MM-DD",
                        "popper-options": { modifiers: [{
            name: 'flip',
            options: {
                fallbackPlacements: ['bottom'],
                allowedAutoPlacements: ['bottom'],
            }
        }]},
                        modelValue: _unref(searchObj).date,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchObj).date) = $event)),
                        "start-placeholder": "开始时间",
                        "end-placeholder": "结束时间"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: search
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => {searchEle.value.resetFields();})
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_dropdown, {
          type: "primary",
          trigger: "click",
          onCommand: handCommand
        }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fixed_actions), (item) => {
                  return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                    key: item.value,
                    command: item.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["command"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_button, { type: "primary" }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createVNode(_component_el_icon, { class: "ml-5" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ArrowDown)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          plain: "",
          class: "ml-20",
          onClick: showRegisterDialog
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(AsyncUploadButton, {
          check: checkImportResult,
          class: "ml-20",
          showBtn: true,
          onVisible: asyncUploadDialogVisible,
          "btn-text": "批量登记入库",
          "dialog-title": '批量导入',
          upFetch: _unref(batchRegisterFixedAssetsApi),
          confirmBtn: {text:'立即导入',loadingText:'正在导入'},
          result: _unref(batchImportResult),
          upParams: {}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_eptBtn, {
              exportFn: _unref(downloadTemplateApi),
              class: "ml-10",
              exportText: '下载固定资产模板',
              isDirect: true
            }, null, 8, ["exportFn"])
          ]),
          _: 1
        }, 8, ["upFetch", "result"])
      ])
    ]),
    _createVNode(RegisterFixedDialog, {
      callback: __props.callback,
      show: _unref(registerFixedDialogInfo).isShow,
      "category-list": __props.categoryList,
      "company-list": __props.companyList,
      "org-list": __props.orgList,
      "register-api": __props.registerApi,
      "users-list-api": __props.usersListApi
    }, null, 8, ["callback", "show", "category-list", "company-list", "org-list", "register-api", "users-list-api"]),
    _createVNode(FixedAssetListDialog, {
      "org-list": __props.orgList,
      "company-list": __props.companyList,
      "category-list": __props.categoryList,
      show: _unref(fixedAssetListDialogInfo).isShow,
      status: _unref(fixedAssetListDialogInfo).status,
      "filter-bind": _unref(fixedAssetListDialogInfo).filterBind,
      onSelect: onAssetSelected
    }, null, 8, ["org-list", "company-list", "category-list", "show", "status", "filter-bind"]),
    _createVNode(_component_el_dialog, {
      class: "lyDialog",
      modelValue: _unref(lyDialogInfo).isShow,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(lyDialogInfo).isShow) = $event)),
      draggable: "",
      width: "1200px"
    }, {
      header: _withCtx(() => [
        _hoisted_7
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_button, {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(lyDialogInfo).isShow=false))
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: ly,
            loading: _unref(lyDialogInfo).loading,
            disabled: _unref(lyDialogInfo).loading
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          class: "lyForm pl-20",
          ref_key: "lyFormRef",
          ref: lyFormRef,
          model: _unref(lyForm)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_el_form_item, {
                label: "领用人",
                prop: "userId",
                class: "flex-1",
                required: "",
                rules: [{required:true,message:'请选择领用人'}]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _unref(lyForm).userId,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(lyForm).userId) = $event)),
                    placeholder: "请输入关键字",
                    remote: "",
                    filterable: "",
                    clearable: "",
                    "remote-method": queryUser,
                    loading: _unref(userInfo).loading,
                    autocomplete: "off"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userInfo).userList, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.userId,
                          label: item.label,
                          value: item.userId
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "loading"])
                ]),
                _: 1
              }),
              _hoisted_9,
              _createVNode(_component_el_form_item, {
                label: "领用日期",
                prop: "date",
                class: "flex-1",
                required: "",
                rules: [{required:true,message:'请选择领用日期'}]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _unref(lyForm).date,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(lyForm).date) = $event)),
                    "value-format": "YYYY-MM-DD",
                    type: "date",
                    placeholder: "领用日期"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (showFixedAssetListDialog(_unref(action_ly))))
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ]),
            _hoisted_11,
            _createVNode(_component_el_table, {
              border: "",
              class: "mt-10",
              data: _unref(fixedAssetListDialogInfo).selectedList,
              "row-key": "id",
              "max-height": "200px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "序号",
                  type: "index",
                  width: "70"
                }),
                _createVNode(_component_el_table_column, {
                  label: "所属团队",
                  prop: "orgName",
                  width: "100",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "所属公司",
                  prop: "companyName",
                  width: "100",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "资产编号",
                  prop: "no",
                  width: "180",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "资产名称",
                  prop: "name",
                  width: "100",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "规格型号",
                  prop: "spec",
                  width: "90",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "电脑设备ID",
                  prop: "deviceId",
                  width: "100",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "资产类别",
                  prop: "categoryName",
                  width: "100",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "单位",
                  prop: "unit",
                  width: "60",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "数量",
                  prop: "count",
                  width: "60",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "使用状态",
                  prop: "statusDesc",
                  width: "100",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  fixed: "right",
                  width: "80",
                  "show-overflow-tooltip": ""
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_el_space, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_link, {
                            type: "danger",
                            onClick: ($event: any) => (deleteBindAsset(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_13
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "tkDialog",
      modelValue: _unref(tkDialogInfo).isShow,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(tkDialogInfo).isShow) = $event)),
      draggable: "",
      width: "1200px"
    }, {
      header: _withCtx(() => [
        _hoisted_17
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_el_button, {
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_unref(tkDialogInfo).isShow=false))
          }, {
            default: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: tk,
            loading: _unref(tkDialogInfo).loading,
            disabled: _unref(tkDialogInfo).loading
          }, {
            default: _withCtx(() => [
              _hoisted_24
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          class: "tkForm pl-20",
          ref_key: "tkFormRef",
          ref: tkFormRef,
          model: _unref(tkForm)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_el_form_item, {
                label: "退库人",
                prop: "userId",
                class: "flex-1",
                required: "",
                rules: [{required:true,message:'请选择退库人'}]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _unref(tkForm).userId,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(tkForm).userId) = $event)),
                    placeholder: "请输入关键字",
                    remote: "",
                    filterable: "",
                    clearable: "",
                    "remote-method": queryUser,
                    loading: _unref(userInfo).loading,
                    autocomplete: "off"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userInfo).userList, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.userId,
                          label: item.label,
                          value: item.userId
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "loading"])
                ]),
                _: 1
              }),
              _hoisted_19,
              _createVNode(_component_el_form_item, {
                label: "退库日期",
                prop: "date",
                class: "flex-1",
                required: "",
                rules: [{required:true,message:'请选择退库日期'}]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _unref(tkForm).date,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(tkForm).date) = $event)),
                    "value-format": "YYYY-MM-DD",
                    type: "date",
                    placeholder: "退库日期"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_el_form_item, {
                label: "退库原因",
                prop: "reason",
                class: "flex-1",
                required: "",
                rules: [{required:true,message:'请输入退库原因'}]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(tkForm).reason,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(tkForm).reason) = $event)),
                    type: "textarea",
                    autosize: { minRows: 3},
                    placeholder: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _hoisted_21,
            _createVNode(_component_el_table, {
              border: "",
              class: "mt-10",
              data: _unref(fixedAssetListDialogInfo).selectedList,
              "row-key": "id",
              "max-height": "200px",
              onSelectionChange: onTkAssetSelected
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "selection",
                  width: "55",
                  fixed: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "所属团队",
                  prop: "orgName",
                  width: "120",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "所属公司",
                  prop: "companyName",
                  width: "120",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "资产编号",
                  prop: "no",
                  width: "205",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "资产名称",
                  prop: "name",
                  width: "120",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "规格型号",
                  prop: "spec",
                  width: "100",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "电脑设备ID",
                  prop: "deviceId",
                  width: "100",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "资产类别",
                  prop: "categoryName",
                  width: "100",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "单位",
                  prop: "unit",
                  width: "60",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "数量",
                  prop: "count",
                  width: "60",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "使用状态",
                  prop: "statusDesc",
                  width: "100"
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "bfDialog",
      modelValue: _unref(bfDialogInfo).isShow,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(bfDialogInfo).isShow) = $event)),
      draggable: "",
      width: "1200px"
    }, {
      header: _withCtx(() => [
        _hoisted_25
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_component_el_button, {
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_unref(bfDialogInfo).isShow=false))
          }, {
            default: _withCtx(() => [
              _hoisted_33
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: bf,
            loading: _unref(bfDialogInfo).loading,
            disabled: _unref(bfDialogInfo).loading
          }, {
            default: _withCtx(() => [
              _hoisted_34
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          class: "bfForm pl-20",
          ref_key: "bfFormRef",
          ref: bfFormRef,
          model: _unref(bfForm)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_el_form_item, {
                label: "报废日期",
                prop: "date",
                class: "flex-1",
                required: "",
                rules: [{required:true,message:'请选择报废日期'}]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _unref(bfForm).date,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(bfForm).date) = $event)),
                    "value-format": "YYYY-MM-DD",
                    type: "date",
                    "disabled-date": disableDate,
                    placeholder: "报废日期"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_el_form_item, {
                label: "报废原因",
                prop: "reason",
                class: "flex-1",
                required: "",
                rules: [{required:true,message:'请输入报废原因'}]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(bfForm).reason,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(bfForm).reason) = $event)),
                    type: "textarea",
                    autosize: { minRows: 3},
                    placeholder: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (showFixedAssetListDialog(_unref(action_bf))))
              }, {
                default: _withCtx(() => [
                  _hoisted_28
                ]),
                _: 1
              })
            ]),
            _hoisted_29,
            _createVNode(_component_el_table, {
              border: "",
              class: "mt-10",
              data: _unref(fixedAssetListDialogInfo).selectedList,
              "row-key": "id",
              "max-height": "200px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "序号",
                  type: "index",
                  width: "55"
                }),
                _createVNode(_component_el_table_column, {
                  label: "所属团队",
                  prop: "orgName",
                  width: "110",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "所属公司",
                  prop: "companyName",
                  width: "110",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "资产编号",
                  prop: "no",
                  width: "185",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "资产名称",
                  prop: "name",
                  width: "110",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "规格型号",
                  prop: "spec",
                  width: "90",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "电脑设备ID",
                  prop: "deviceId",
                  width: "100",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "资产类别",
                  prop: "categoryName",
                  width: "100",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "单位",
                  prop: "unit",
                  width: "60",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "数量",
                  prop: "count",
                  width: "60",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "使用状态",
                  prop: "statusDesc",
                  width: "90",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  fixed: "right",
                  width: "70",
                  "show-overflow-tooltip": ""
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_el_space, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_link, {
                            type: "danger",
                            onClick: ($event: any) => (deleteBindAsset(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_31
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})